import React from 'react'
import { Button, Modal, Form, FloatingLabel } from 'react-bootstrap';
import { useState } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';




 
  const GstRobo = () => {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [number, setNumber] = useState('')
    const [company, setCompany] = useState('')
    const [statusCode, setStatusCode] = useState('')
    const [message, setMessage] = useState('')

const [show, setShow] = useState(false);

const handleClose = () => setShow(false);
const handleShow = () => setShow(true);


const API_PATH = 'http://amosta.com/reactJs/GstRoboInsert.php';
function axios2() {

axios({
  method: 'post',
  url: API_PATH,
  headers: {
    'content-type': 'application/json'

  },
  data: {
    "name": name,
    "email": email,
    "number": number,
    "company": company

  }
})
  .then(result => {
    if (result.data.statusCode === 200) {
      setStatusCode(result.data.statusCode)
      setMessage(result.data.message)
      window.location.reload(false)
    } else {
      setStatusCode(result.data.statusCode)
      setMessage(result.data.message)
    }
    console.log(result);
  })
  .catch(error => {
    console.log(error)
  });
}
  return (
    <>
      <div className="container-fluid">
        <div className="container bg-light">
          <div className="row">
            <div className="col-sm-12 col-md-6 order-md-2 text-center mt-5"><img className='img-fluid h-75' src="assets/images/gst-robo-about.png" alt="gst-robo-about" /></div>
            <div className="col-sm-12 col-md-6 mt-5">
              <h1 className='mb-3'>About GSTrobo</h1>
              <p align='justify'>GSTrobo is Binary Semantics SaaS platform providing GST, E-Way Bill and E-Invoicing Software enabling its users with Billing, Data Preparation and Validation services and support. We are a new age GST Suvidha Provider - GSP appointed by Goods and Services Tax Network (GSTN) to provide a web platform compiling with all the regulatory requirements of the GST law to enable the taxpayer to do the GST compliances.</p>
              <p align='justify'>Spanning over a period of over 3 decades, we have built a strong technology expertise and deep industry knowledge in multiple business lines and domains. Our company is highly versatile and adopt agile methodology, offering end-to-end bespoke software solutions and services. We have clientele across several industry segments such as Automobiles, Manufacturing, FMCG, Technology, Insurance, Travel, Hospitality and B2B Publishing.</p>
            </div>
          </div>
        </div>

        <div className="container gstrobo-section-2 text-center">
          <h1 className='mt-5'>GST Software and GST Solutions</h1>
          <img className='img-fluid' src="assets/images/infographics.jpg" alt="" />
          <Button className='know-more-btn' onClick={handleShow}>
            Know More
          </Button>

          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Request a Callback</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <h5>{statusCode}</h5>
                        <h5>{message}</h5>
                            <Form autoComplete="off">
                                <h3 className='mb-3'>Request a Call</h3>
                                <FloatingLabel controlId='fullName' label='Full Name' className='mb-3'>
                                    <Form.Control type='text' placeholder='Full Name' id='name' name="name" onChange={(e) => setName(e.target.value)} required />
                                </FloatingLabel>
                                <FloatingLabel controlId='phone' label='Mobile Number' className='mb-3'>
                                    <Form.Control type='number' placeholder='Phone number' id='number' name="number" onChange={(e) => setNumber(e.target.value)} required />
                                </FloatingLabel>
                                <FloatingLabel controlId='emailId' label='Email Id' className='mb-3'>
                                    <Form.Control type='email' placeholder='name@example.com' id='email' name="email" onChange={(e) => setEmail(e.target.value)} required />
                                </FloatingLabel>
                                <FloatingLabel controlId='companyName' label='Company Name' className='mb-3'>
                                    <Form.Control type='text' placeholder='Company Name' id='company' name="company" onChange={(e) => setCompany(e.target.value)} required />
                                </FloatingLabel>
                                {/* <Button type="button" onClick={axios2} className='text-center mt-3' variant='success'>Submit</Button> */}
                            </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" className='me-auto' onClick={axios2} >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <div className="container gstrobo-section-3 bg-light mt-5 text-center pb-5">
                <h1 className='pt-5'><span style={{ color: '#f43f47' }}>GST</span> Products</h1>
                <p className='text-muted'>Ensuring Compliance, Reliability & Efficiency</p>
                <div className="gstrobo-cards">
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/invoice.png" alt="" />
                        <h4 className='mt-3'>GST Software</h4>
                        <Link to='/gst-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/real-time-goods.png" alt="" />
                        <h4 className='mt-3'>E-Way Bill Software</h4>
                        <Link to='/e-way-bill-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/one-click-icon.png" alt="" />
                        <h4 className='mt-3'>E-Invoicing Software</h4>
                        <Link to='/e-invoicing-software'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/api.png" alt="" />
                        <h4 className='mt-3'>GST & E-Way Bill API</h4>
                        <Link to='/gst-e-way-bill-api'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/reconcile.png" alt="" />
                        <h4 className='mt-3'>Intelligence Insight</h4>
                        <Link to='/intelligence-insight'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                    <div className="card gst-card shadow">
                        <img className='img-fluid gst-card-img' src="assets/images/ledger.png" alt="" />
                        <h4 className='mt-3'>Value Added Tools</h4>
                        <Link to='/value-added-tools'><Button className='btn-sm mt-3' variant='outline-success'>Know more</Button></Link>
                    </div>
                </div>
            </div>
        <div className="container gstrobo-section-4 mt-5 text-center pb-5">
          <h1>Why Choose <span style={{ color: '#f43f47' }}>GSTrobo</span>  GST, E-Invoicing & Eway Bill Software?</h1>
          <p className='text-muted'>Trusted By India's Top Enterprises Across Various Industries!</p>
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <div className="container mt-5">
                <div className="choose-gst-cards">
                  <div className="round-cards">
                    <img className='img-fluid round-cards-logo' src="./assets/images/ease.png" alt="" />
                  </div>
                </div>
                <div className='card-body'>
                  <h4 className='m-3'>Ease of Usage</h4>
                  <p className='f-1 text-muted'>Seamless and user-friendly GST and EWB solutions and APIs</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="container mt-5">
                <div className="choose-gst-cards">
                  <div className="round-cards">
                    <img className='img-fluid round-cards-logo' src="./assets/images/secure.png" alt="" />
                  </div>
                </div>
                <div className='card-body'>
                  <h4 className='m-3'>Secure & Reliable</h4>
                  <p className='f-1 text-muted'>With ISO, VAPT certificate and 2-factor authentication on HTTPS secured gateway, your overall process is secure & safe</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="container mt-5">
                <div className="choose-gst-cards">
                  <div className="round-cards">
                    <img className='img-fluid round-cards-logo' src="./assets/images/customer.png" alt="" />
                  </div>
                </div>
                <div className='card-body'>
                  <h4 className='m-3'>Customer Focused</h4>
                  <p className='f-1 text-muted'>Highly knowledgeable dedicated account manager & 12x6 service support over phone and email</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="container mt-5">
                <div className="choose-gst-cards">
                  <div className="round-cards">
                    <img className='img-fluid round-cards-logo' src="./assets/images/notifications.png" alt="" />
                  </div>
                </div>
                <div className='card-body'>
                  <h4 className='m-3'>Compliance Alert & Notifications</h4>
                  <p className='f-1 text-muted'>Our system sends out automated reminders and ensure compliance is done on time</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="container mt-5">
                <div className="choose-gst-cards">
                  <div className="round-cards">
                    <img className='img-fluid round-cards-logo' src="./assets/images/approve.png" alt="" />
                  </div>
                </div>
                <div className='card-body'>
                  <h4 className='m-3'>Who / What & Where</h4>
                  <p className='f-1 text-muted'>What each user can access and do in our platform</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="container mt-5">
                <div className="choose-gst-cards">
                  <div className="round-cards">
                    <img className='img-fluid round-cards-logo' src="./assets/images/trusted.png" alt="" />
                  </div>
                </div>
                <div className='card-body'>
                  <h4 className='m-3'>Trusted Technology Partner</h4>
                  <p className='f-1 text-muted'>Quality standard certificates ISO 27001:2013 & ISO 9001: 2015 and over 3 decades of technological experience</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default  GstRobo;


